import { Cell } from "react-table";
import { ContractVisitorListModel } from "src/api/visitor/visitor-types";
import DetailLink from "src/components/DetailLink";
import PagePath from "src/pagePath.json";

export const VisitorLinkCell = (props: Cell<ContractVisitorListModel>) => {
  let detailPath = `${PagePath.visitor.detail.replace(":contractApplyNumber", `${props.row.original.contractApplyNumber}`)}`;

  detailPath = `${detailPath.replace(":visitApplyNumber", `${props.row.original.visitApplyNumber}`)}`;

  return (
    <div>
      {props.value ? (
        <DetailLink to={detailPath} className="text-underline">
          {props.value}
        </DetailLink>
      ) : (
        "-"
      )}
    </div>
  );
};
